import { Flex } from '@osmosis/tailwind-ui/components/Box';
import React from 'react';
import { NavList } from '@osmosis/shared/types/learndb/learnData';
import { NavListItem } from '@osmosis/shared/types/learndb/learnData';
import { cn } from '@osmosis/tailwind-ui/helpers/classes';

import VideoList from './VideoList';

export type PlaylistNavListProps = {
  navLists: NavList[];
  playlistName: string;
  selectionMode: boolean;
  title: string;
  selectedItems: NavListItem[];
  selectedTab: string;
  classNames?: {
    container?: string;
  };
  onChangeCheckedValue: (item: NavListItem, checked: boolean) => void;
};

/**
 * .
 */
export default function PlaylistNavList({
  navLists,
  playlistName,
  selectionMode,
  title,
  selectedItems,
  selectedTab,
  classNames = {},
  onChangeCheckedValue,
}: PlaylistNavListProps): JSX.Element {
  return (
    <Flex
      className={cn(
        `flex-col overflow-y-scroll relative px-4`,
        classNames.container,
      )}
    >
      {navLists.map((section, index) => {
        return (
          <VideoList
            key={index}
            index={index}
            className={`mb-2`}
            data={section}
            selectionMode={selectionMode}
            currentTitle={title}
            selectedItems={selectedItems}
            selectedTab={selectedTab}
            playlistName={playlistName}
            onChangeCheckedValue={onChangeCheckedValue}
          />
        );
      })}
    </Flex>
  );
}
